// components/Footer.js
'use client';
import Call from '@/assets/icons/icon-call.svg';
import LogoSvg from '@/assets/icons/radius_sariq_logo.svg';
import Humo from '@/assets/images/humo.svg';
import Mastercard from '@/assets/images/Mastercard.svg';
import Uzcard from '@/assets/images/uzcard.svg';
import Visa from '@/assets/images/Visa.svg';
import { MenuDetailsFragment } from '@/graphql';
import { useTranslatedData } from '@/hooks/useTranslatedData';
import { Link } from '@/i18n/navigation';
import { useLocale, useTranslations } from 'next-intl';
import Skeleton from 'react-loading-skeleton';
import styles from './footer.module.scss';
import FooterMobileContent from './footerMobileContent';

const Footer = ({
  menu,
  loading,
}: {
  menu: MenuDetailsFragment | null | undefined;
  loading: boolean;
}) => {
  const t = useTranslations('Footer');
  const currentYear = new Date().getFullYear();
  const locale = useLocale();

  const footerMenu = useTranslatedData(menu?.items || [], ['name']);

  return (
    <>
      {/* <div>
        <Thumbnails />
      </div> */}
      <footer className={styles.footer}>
        <div className={styles.footer__wrapper}>
          <div className={styles.footer__left}>
            <Link href={'/'} className={styles.footer__topLogo}>
              <LogoSvg />
            </Link>
            <div className={styles.footer__paymentMethods}>
              <div className={styles.footer__paymentIcon}>
                <Visa />
              </div>
              <div className={styles.footer__paymentIcon}>
                <Mastercard />
              </div>
              <div className={styles.footer__paymentIcon}>
                <Humo />
              </div>
              <div className={styles.footer__paymentIcon}>
                <Uzcard />
              </div>
            </div>
          </div>

          <div className={styles.footer__middle}>
            {loading
              ? Array.from({ length: 3 }).map((_, index) => (
                  <div key={index} className={styles.skeletonForMobile}>
                    <Skeleton />
                  </div>
                ))
              : footerMenu?.map((i, id) => (
                  <div
                    key={id + '_' + i.name}
                    className={styles.footer__section}
                  >
                    <div className={styles.footer__title}>{i.name}</div>
                    {i.children?.map((c, cid) => (
                      <div key={cid}>
                        <Link
                          className={styles.footer__link}
                          href={c.url || '#'}
                        >
                          {locale === 'ru' ? c?.name : c?.translation?.name}
                        </Link>
                      </div>
                    ))}
                  </div>
                ))}
          </div>

          <div className={styles.footer__middleMobile}>
            <FooterMobileContent menu={menu} loading={loading} />
          </div>

          <div className={styles.footer__right}>
            <div className={styles.footer__contactInfo}>
              <div className={styles.footer__phone}>+998 (71) 200 31 00</div>
              <div className={styles.footer__hours}>{t('schedule')}</div>
              <button type="button" className={styles.footer__callButton}>
                <Link
                  href={'tel:+998 (71) 200 31 00'}
                  className={styles.footer__linkButton}
                >
                  <Call /> <span>{t('order-call')}</span>
                </Link>
              </button>
            </div>
            <div className={styles.footer__contacts}>
              <div className={styles.footer__contactsTitle}>
                {t('contacts')}
              </div>
              <p className={styles.footer__contactsSubTitle}>{t('address')}</p>
            </div>
            <div className={styles.footer__socialLinks}>
              <div className={styles.footer__socialLinksTitle}>
                {t('our-socials')}
              </div>
              <div className={styles.footer__socialLinksWrapper}>
                <Link
                  href="https://www.facebook.com/share/16WG5WCBFZ/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footer__socialLink}
                >
                  Facebook
                </Link>
                <Link
                  href="https://t.me/radius_uz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footer__socialLink}
                >
                  Telegram
                </Link>
                <Link
                  href="https://www.instagram.com/radius_uz?igsh=aXF3MzkwZXI2aTFm"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footer__socialLink}
                >
                  Instagram
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer__BottomWrapper}>
          <div className={styles.footer__footerText}>{t('user-agreement')}</div>
          <div className={styles.footer__footerText}>
            {t('privacy-policy', { year: currentYear })}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
